module.exports = __webpack_public_path__ + "img/transfer_266330d.webp";